import React from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CarouselWrapper } from "./styled";
import DogeCarousel from "Component/DogeCarousel";

const MintedList = () => {
  return (
    <CarouselWrapper>
      <DogeCarousel />
    </CarouselWrapper>
  );
};

export default MintedList;
